import { css } from '@emotion/react';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../utils/currency-helpers';
import { PlaceholderSkeleton } from '../PlaceholderSkeleton';

type SummaryItemProps = {
  label: string;
  amount?: number;
  loading: boolean;
  isAmountValue?: boolean;
};

export const SummaryItem = ({ label, amount, isAmountValue = true, loading }: SummaryItemProps) => {
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });
  return (
    <div
      css={css`
        display: flex;
        flex-flow: column;
      `}
    >
      <Text
        size={isMobile ? 'small' : 'medium'}
        css={[{ margin: 0 }, isMobile ? { color: theme.colorsV2.black(75) } : {}]}
        color='subdued'
      >
        {label}
      </Text>
      <PlaceholderSkeleton
        loading={loading}
        as='span'
        height='1.25rem'
        margin={theme.spacing(1, 0, 0, 0)}
        css={{ display: 'block' }}
      >
        <Heading level={isMobile ? 3 : 2} css={isMobile ? { color: theme.colorsV2.black(85) } : {}}>
          {(isAmountValue ? formatCentsToCurrency(amount) : amount) ?? '-'}
        </Heading>
      </PlaceholderSkeleton>
    </div>
  );
};
